export const routes = {
    home: '/',
    orders: '/orders',
    update_order:":id",
    login: 'login',
    products: '/product',
    product_create:'/product/create',
    product_update:'/product/update/:id',
    // create:"create",

}